import { BALL_R } from './constants';
import type { Ball } from './types';

export function createBall(x: number, y: number, attached: boolean): Ball {
  return {
    x,
    y,
    vx: 0,
    vy: 0,
    r: BALL_R,
    attached,
    fire: false,
    piercing: false,
    trail: [],
  };
}
